<template>
  <tr
    class="v-datatable__row"
  >
    <td class="text-xs-left">
      <v-checkbox
        v-model="props.selected"
        hide-details
      />
    </td>
    <td>{{ props.item.name }}</td>
  </tr>
</template>
<script>

export default {
  name: 'SettingsVatMethodRow',

  props: {
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
